import { useFeatureFlagsContext } from 'src/provider/FeatureFlagProvider';

export const useFeatureFlagEnabled = (flagKey: string): boolean => {
  const { featureFlags } = useFeatureFlagsContext();

  if (!featureFlags) return false;

  return featureFlags[flagKey]?.value === 'on';
};
